import React, { useEffect, useRef, useState } from "react";
import "../../styles/twoWayInterview.css";
import TwoWayNavbar from "./TwoWayNavbar";
import TwoWayMain from "./TwoWayMain";
import Footer from "../Footer";
import {
  addMonitoringToolDataApi,
  candScreenRejoinApi,
  candVideoRejoinApi,
  updateAudioAnomalyApi,
  updateConversationHistoryApi,
  uploadCandScreenApi,
  uploadCandVideoApi,
  uploadScreenshotApi,
  uploadSnapshotApi,
  uploadSnapShotFruad,
} from "../../api";
import { addtoScreenShareQueue } from "../recordings/handleScreenBlobs";
import { addtoVideoQueue } from "../recordings/handleVideoBlobs";
import WebUtils from "../utils/WebUtils";
import Loader from "../Loader";
import DraggableVideo from "./TwoWaysDraggableVideo";
import { notification, Tour } from "antd";
import InterviewEndModal from "./modals/InterviewEndModal";
import InterviewRejoinModal from "./modals/InterviewRejoinModal";
import EndInterviewRequestModal from "./modals/EndInterviewRequestModal";
import DisconnectRejoinModal from "./modals/DisconnectRejoinModal";
import TranscriptionClosedRejoinModal from "./modals/TranscriptionClosedRejoinModal";
import MonitorDisconnectedModal from "../monitorTools/insideInterview/MonitorDisconnectedModal";

const token = "exdsfrty7365378TerdstAIOP!@123";

function TwoWayInterview({
  socket,
  deepgramStatus,
  setDeepgramStatus,
  interviewData,
  ip,
  conversationHistory,
  previewConfig,
  currentVideoStream,
  screenShareStream,
  currentAudioStream,
}) {
  const [loading, setLoading] = useState(false);
  const [interviewMode, setInterviewMode] = useState("Manual");
  const [videoRecordingFlag, setVideoRecordingFlag] = useState(false);
  const [screenRecordingFlag, setScreenRecordingFlag] = useState(false);
  const [snapshotFlag, setSnapshotFlag] = useState(false);
  const [screenshotFlag, setScreenshotFlag] = useState(false);
  const [deepgramAudioRecorder, setDeepgramAudioRecorder] = useState(null);
  const [chanceOverModal, setChanceOverModal] = useState(false);
  const [rejoinModal, setRejoinModal] = useState(false);
  const [disconnectRejoinModal, setDisconnectRejoinModal] = useState(false);
  const [monitorDisconnectModal, setMonitorDisconnectModal] = useState(false);
  const [transcriptionClosedRejoinModal, setTranscriptionClosedRejoinModal] =
    useState(false);
  const [endInterviewRequestModal, setEndInterviewRequestModal] =
    useState(false);
  const allowUnloadRef = useRef(false);
  const [isHealthOk, setIsHealthOk] = useState(true);
  const [monitorStatus, setMonitorStatus] = useState({
    app_count: 0,
    display_count: 0,
    apps: [],
    displays: [],
    has_violations: false,
    suspicious_apps: [],
    suspicious_count: 0,
    topology: "single_display",
    violation_count: 0,
    violations: [],
  });

  const checkHealth = async () => {
    try {
      const response = await fetch("http://localhost:9191/health", {
        method: "GET",
      });

      const data = await response.json();

      if (data?.data?.status === "ok") {
        setIsHealthOk(true);
      } else {
        setIsHealthOk(false);
      }
    } catch (error) {
      console.error("Error calling health API:", error);
      setIsHealthOk(false);
    }
  };

  const callAddMonitoringToolDataApi = (statusData, monitoringToolDetected) => {
    const url =
      addMonitoringToolDataApi + `?interviewId=${interviewData?.interviewId}`;

    let stamp =
      conversationHistory?.interviewDuration - timeRemainingRef.current;

    const requestBody = {
      elapsedTime: stamp,
      totalApplicationsRunning: statusData?.app_count,
      totalScreensRunning: statusData?.display_count,
      applicationNames: statusData?.apps,
      screenNames: statusData?.displays,
      monitoringToolDetected,
    };

    WebUtils.httpOperations(url, requestBody, "POST")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchMonitorStatus = async (callApi = true) => {
    try {
      const res = await fetch("http://localhost:9191/api/v1/status", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const json = await res.json();
      if (json?.resultStatusInfo?.resultCode === "SUCCESS") {
        if (callApi) {
          callAddMonitoringToolDataApi(json?.data, true);
        }
        setMonitorStatus({
          app_count: json.data.app_count,
          display_count: json.data.display_count,
          apps: json.data.apps || [],
          displays: json.data.displays || [],
          suspicious_apps: json.data.suspicious_apps || [],
          suspicious_count: json.data.suspicious_count || 0,
          topology: json.data.topology || "single_display",
          violation_count: json.data.violation_count || 0,
          violations: json.data.violations || [],
        });
        if (json?.data?.suspicious_count > 0 || json?.data?.display_count > 1) {
          notification.warning({
            message: (
              <div className="text-amber-500 font-semibold">
                Violations detected!
              </div>
            ),
            description: (
              <div className="text-gray-600 text-[.85rem]">
                You have opened suspicious apps or connected more displays.
                Please hover over the <b>Monitoring badge</b> and resolve the
                issues to maintain interview integrity.
              </div>
            ),
            placement: "top",
            duration: 8,
          });
        }
      }
    } catch (err) {
      console.error("Monitor status fetch failed:", err);
    }
  };

  const audioQueueRef = useRef([]); //bot audio queue
  const timeIntervalRef = useRef(null);
  const conversationIntervalRef = useRef(null);
  let chanceLeft = useRef(previewConfig?.totalFraudulentChancesLeft);
  let fraudSnapshotAPiCall = useRef(false);
  const endInterviewClickedFlag = useRef(false);

  const audioContextRef = useRef(
    new (window.AudioContext || window.webkitAudioContext)(),
  );
  const mixedAudioDestinationRef = useRef(
    audioContextRef.current.createMediaStreamDestination(),
  );
  const microphoneGainNodeRef = useRef(audioContextRef.current.createGain());

  const screenRejoinApi = () => {
    let url = `${candScreenRejoinApi}?interviewId=${interviewData?.interviewId}`;
    WebUtils.httpOperations(url, {}, "POST")
      .then((response) => {})
      .catch((err) => console.error(err));
  };
  const videoRejoinApi = () => {
    let url = `${candVideoRejoinApi}?interviewId=${interviewData?.interviewId}`;
    WebUtils.httpOperations(url, {}, "POST")
      .then((response) => {})
      .catch((err) => console.error(err));
  };

  const uploadSnapshot = () => {
    if (currentVideoStream) {
      const video = document.createElement("video");
      video.style.display = "none";
      const snap = document.createElement("canvas");
      snap.style.display = "none";

      video.srcObject = currentVideoStream;
      video.onloadedmetadata = () => {
        video.play();
        snap.width = video.videoWidth;
        snap.height = video.videoHeight;
        snap.getContext("2d").drawImage(video, 0, 0, snap.width, snap.height);

        snap.toBlob((snapBlob) => {
          if (snapBlob) {
            const file = new File([snapBlob], "snap.png");
            const formdata = new FormData();
            formdata.append("snapshot", file);

            const url = `${uploadSnapshotApi}?interviewId=${interviewData?.interviewId}`;
            WebUtils.httpOperations(url, formdata, "POST")
              .then((response) => {})
              .catch((err) => console.error(err));
          }

          video.remove();
          snap.remove();
        });
      };

      video.onerror = (e) => {
        console.error("Video element error:", e);
        video.remove();
        snap.remove();
      };
    }
  };
  const uploadScreenshot = () => {
    if (screenShareStream) {
      let video = document.createElement("video");
      video.style.display = "None!important";
      let snap = document.createElement("canvas");
      snap.style.display = "None!important";
      video.srcObject = screenShareStream;
      video.onloadedmetadata = () => {
        snap.width = video.videoWidth;
        snap.height = video.videoHeight;
        snap.getContext("2d").drawImage(video, 0, 0, snap.width, snap.height);
        snap.toBlob((snapBlob) => {
          let file = new File([snapBlob], "screen_share_snapshot.png");
          let formdata = new FormData();
          formdata.append("screenshot", file);

          const url = `${uploadScreenshotApi}?interviewId=${interviewData?.interviewId}`;
          WebUtils.httpOperations(url, formdata, "POST")
            .then((response) => {})
            .catch((err) => console.error(err));
        });
      };
      video.play();
      video.remove();
      snap.remove();
    } else {
      console.log("Could not access screen share");
    }
  };

  const [videoRecorder, setVideoRecorder] = useState(null);
  const videoBlobQueueRef = useRef([]);
  const videoRejoinApiFlag = useRef(false);
  const apiVideoQueue = useRef([]);

  const startVideoRecording = async (videoStream, audioStream) => {
    let options = {
      videoBitsPerSecond: 600000,
      mimeType: 'video/webm;codecs="vp9,opus"',
    };

    await audioContextRef.current.resume();
    let microphoneAudioSource =
      audioContextRef.current.createMediaStreamSource(audioStream);
    microphoneGainNodeRef.current.gain.value = 1;

    microphoneAudioSource.connect(microphoneGainNodeRef.current);
    microphoneGainNodeRef.current.connect(mixedAudioDestinationRef.current);

    let combinedStream = new MediaStream();
    combinedStream.addTrack(videoStream.getVideoTracks()[0]);
    combinedStream.addTrack(
      mixedAudioDestinationRef.current.stream.getAudioTracks()[0],
    );

    let recorder = new MediaRecorder(combinedStream, options);

    const uploadVideoRecording = (e) => {
      let blobData = new Blob([e.data], { type: "video/webm" });

      if (blobData.size === 0) {
        if (videoRejoinApiFlag.current === true) {
          videoRejoinApiFlag.current = false;
        }
        return;
      }

      let formData = new FormData();
      formData.append("video", blobData, "videopart.webm");

      let formUrl = `${uploadCandVideoApi}?interviewId=${interviewData?.interviewId}`;
      addtoVideoQueue(
        formData,
        apiVideoQueue,
        videoBlobQueueRef,
        formUrl,
        videoRejoinApiFlag,
        videoRejoinApi,
      );
    };

    recorder.onstart = () => {
      console.log("Video started recording");
    };

    recorder.ondataavailable = (e) => {
      // console.log("Webcam Data available");
      uploadVideoRecording(e);
    };

    recorder.onstop = () => {
      console.log("Webcam recording stopped!");
    };

    recorder.start(previewConfig?.candidateVideoUploadInterval * 1000 || 60000);

    setVideoRecorder(recorder);
  };

  const [screenRecorder, setScreenRecorder] = useState(null);
  const screenShareBlobQueueRef = useRef([]);
  const screenShareRejoinApiFlag = useRef(false);
  const apiScreenShareQueue = useRef([]);

  const startScreenRecording = async (screenStream, audioStream) => {
    let options = {
      videoBitsPerSecond: 200000,
      mimeType: 'video/webm;codecs="vp8,opus"',
    };

    await audioContextRef.current.resume();
    let microphoneAudioSource =
      audioContextRef.current.createMediaStreamSource(audioStream);
    microphoneGainNodeRef.current.gain.value = 1;

    microphoneAudioSource.connect(microphoneGainNodeRef.current);
    microphoneGainNodeRef.current.connect(mixedAudioDestinationRef.current);

    let combinedStream = new MediaStream();
    combinedStream.addTrack(screenStream.getVideoTracks()[0]);
    combinedStream.addTrack(
      mixedAudioDestinationRef.current.stream.getAudioTracks()[0],
    );

    const recorder = new MediaRecorder(combinedStream, options);

    const uploadScreenShareRecording = async (e) => {
      let blobData = new Blob([e.data], { type: "video/webm" });

      if (blobData.size === 0) {
        if (screenShareRejoinApiFlag.current === true) {
          screenShareRejoinApiFlag.current = false;
        }
        return;
      }

      let formData = new FormData();
      formData.append("video", blobData, "videopart.webm");

      let formUrl = `${uploadCandScreenApi}?interviewId=${interviewData?.interviewId}`;
      addtoScreenShareQueue(
        formData,
        apiScreenShareQueue,
        screenShareBlobQueueRef,
        formUrl,
        screenShareRejoinApiFlag,
        screenRejoinApi,
      );
    };

    recorder.onstart = () => {
      // console.log("Screen started recording");
    };

    recorder.ondataavailable = (e) => {
      // console.log("ScreenData available");
      uploadScreenShareRecording(e);
    };

    recorder.onstop = () => {
      // console.log("Screen recording stopped");
    };
    recorder.start(previewConfig?.screenVideoUploadInterval * 1000 || 50000);
    setScreenRecorder(recorder);
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (allowUnloadRef.current) return; // allow redirect without warning

      event.preventDefault();
      event.returnValue = "";
      setEndInterviewRequestModal(true);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (audioContextRef.current.state === "suspended") {
      // console.log("audio context resumed");
      audioContextRef.current.resume();
    }
  }, []);

  //upload snapshots and screenshots
  const snapshotIntervalRef = useRef(null);
  const screenshotIntervalRef = useRef(null);
  useEffect(() => {
    if (previewConfig?.videoRecordingRequired && !snapshotFlag) {
      setTimeout(() => {
        uploadSnapshot();
      }, 3000);
      snapshotIntervalRef.current = setInterval(
        () => {
          uploadSnapshot();
        },
        previewConfig?.snapshotUploadInterval * 1000 || 40000,
      );
      setSnapshotFlag(true);
    }
    if (previewConfig?.screenRecordingRequired && !screenshotFlag) {
      setTimeout(() => {
        uploadScreenshot();
      }, 3000);
      screenshotIntervalRef.current = setInterval(
        () => {
          uploadScreenshot();
        },
        previewConfig?.screenshotUploadInterval * 1000 || 45000,
      );
      setScreenshotFlag(true);
    }
    return () => {
      clearInterval(snapshotIntervalRef.current);
      clearInterval(screenshotIntervalRef.current);
    };
  }, []);

  //start video and screen recordings
  useEffect(() => {
    if (
      currentVideoStream &&
      currentAudioStream &&
      previewConfig?.videoRecordingRequired &&
      !videoRecordingFlag
    ) {
      startVideoRecording(currentVideoStream, currentAudioStream);
      videoRejoinApi();
      setVideoRecordingFlag(true);
    }
    if (
      screenShareStream &&
      currentAudioStream &&
      previewConfig?.screenRecordingRequired &&
      !screenRecordingFlag
    ) {
      startScreenRecording(screenShareStream, currentAudioStream);
      screenRejoinApi();
      setScreenRecordingFlag(true);
    }

    return () => {
      if (videoRecorder) videoRecorder.stop();
      if (screenRecorder) screenRecorder.stop();
    };
  }, []);

  //Conversation history and timer
  const [chatMessages, setChatMessages] = useState(null);
  const [timeRemaining, setTimeRemaining] = useState(null);

  const chatMessagesRef = useRef(chatMessages);
  const timeRemainingRef = useRef(timeRemaining);

  const updateConverstionHistory = () => {
    const url = updateConversationHistoryApi;

    const requestBody = {
      interviewId: interviewData?.interviewId,
      interviewRemainingTime: timeRemainingRef.current,
      conversation: chatMessagesRef.current,
    };
    const resetBody = {
      interviewId: interviewData?.interviewId,
      interviewRemainingTime: 1200,
      conversation: [],
    };

    WebUtils.httpOperations(url, requestBody, "POST")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const callAudioAnomalyApi = (anomalyType) => {
    const url =
      updateAudioAnomalyApi + `?interviewId=${interviewData?.interviewId}`;

    let stamp =
      conversationHistory?.interviewDuration - timeRemainingRef.current;
    if (stamp >= 2) {
      stamp = stamp - 2;
    }

    const requestBody = {
      timestamp: stamp,
      audioAnomalyType: anomalyType,
    };

    WebUtils.httpOperations(url, requestBody, "POST")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (
      conversationHistory?.interviewHistory &&
      conversationHistory?.interviewTimeLeft !== null
    ) {
      setChatMessages(conversationHistory?.interviewHistory);
      setTimeRemaining(conversationHistory?.interviewTimeLeft);
    }
  }, [conversationHistory]);

  useEffect(() => {
    if (conversationHistory?.interviewTimeLeft !== null) {
      timeIntervalRef.current = setInterval(() => {
        setTimeRemaining((prevTime) => {
          if (prevTime > 0) {
            return prevTime - 1;
          } else {
            clearInterval(timeIntervalRef.current); // Stop the timer when it reaches 0
            return 0;
          }
        });
      }, 1000);

      conversationIntervalRef.current = setInterval(
        () => {
          updateConverstionHistory();
        },
        previewConfig?.chatHistoryUpdateInterval * 1000 || 60000,
      );
    }

    return () => {
      clearInterval(timeIntervalRef.current);
      clearInterval(conversationIntervalRef.current);
    };
  }, [conversationHistory]);

  useEffect(() => {
    chatMessagesRef.current = chatMessages;
  }, [chatMessages]);

  useEffect(() => {
    timeRemainingRef.current = timeRemaining;
  }, [timeRemaining]);

  useEffect(() => {
    let reminderInterval = null;
    if (socket && socket.connected) {
      reminderInterval = setInterval(() => {
        socket.emit("TimeReminder", timeRemainingRef.current);
      }, 60000);

      socket.on("EndInterviewRequested", () => {
        setEndInterviewRequestModal(true);
      });
      socket.on("SpeakerAnomaly", (anomaly) => {
        if (anomaly === "MultipleSpeakers") {
          callAudioAnomalyApi("Multiple Speakers Detected");
          notification.warning({
            message: "Warning!",
            description: `Multiple speakers detected!`,
            placement: "topRight",
            duration: 2,
          });
        } else if (anomaly === "SpeakerChanged") {
          callAudioAnomalyApi("Speaker Change Detected");
          notification.warning({
            message: "Warning!",
            description: `Speaker change detected!`,
            placement: "topRight",
            duration: 2,
          });
        }
      });
    }

    socket?.on("disconnect", (reason) => {
      console.log("Socket disconnected: ", reason);
      setDisconnectRejoinModal(true);
    });
    socket?.on("TrancriptionSocketClosed", () => {
      console.log("Transcription socket closed.");
      if (!endInterviewClickedFlag.current) {
        setTranscriptionClosedRejoinModal(true);
      }
    });

    return () => {
      clearInterval(reminderInterval);
    };
  }, [socket]);

  //stop all recordings and intervals
  const stopRecording = () => {
    audioQueueRef.current = [];
    if (videoRecorder) videoRecorder.stop();
    if (screenRecorder) screenRecorder.stop();
    if (deepgramAudioRecorder) deepgramAudioRecorder.stop();
    if (snapshotIntervalRef.current) clearInterval(snapshotIntervalRef.current);
    if (screenshotIntervalRef.current)
      clearInterval(screenshotIntervalRef.current);
    if (timeIntervalRef.current) clearInterval(timeIntervalRef.current);
    if (conversationIntervalRef.current)
      clearInterval(conversationIntervalRef.current);
    // socket.disconnect();
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (screenShareStream) {
        fraudSnapshotAPiCall.current = false;
        let logs = WebUtils.logData();
        logs = {
          ...logs,
          role: "",
          name: "",
          ipAddress: ip,
          logCode: "FRAUD SCREENSHOT",
          logMessage: "FRAUD SCREENSHOT CAPTURED",
        };
        let req = {
          logs,
          timeStamp:
            conversationHistory?.interviewDuration - timeRemainingRef?.current,
        };
        // console.log(req);

        if (document.visibilityState === "hidden" && chanceLeft.current >= 0) {
          --chanceLeft.current;
          if (chanceLeft.current >= 0) {
            setTimeout(() => {
              let video = document.createElement("video");
              video.style.display = "None!important";
              let snap = document.createElement("canvas");
              snap.style.display = "None!important";
              video.srcObject = screenShareStream;

              video.onloadedmetadata = () => {
                snap.width = video.videoWidth;
                snap.height = video.videoHeight;

                // Capture the screenshot
                const context = snap.getContext("2d");
                context.drawImage(video, 0, 0, snap.width, snap.height);

                // Convert the screenshot to a Blob
                snap.toBlob((snapBlob) => {
                  const file = new File(
                    [snapBlob],
                    "screen_share_snapshot.png",
                  );
                  const formdata = new FormData();
                  formdata.append("screenshot", file);
                  formdata.append("fraudSnapshotData", JSON.stringify(req));

                  const url = `${uploadSnapShotFruad}?interviewId=${interviewData?.interviewId}`;

                  // Trigger the API call
                  WebUtils.httpOperations(url, formdata, "POST")
                    .then((response) => {
                      fraudSnapshotAPiCall.current = true;
                      // --chanceLeft.current;
                    })
                    .catch((err) => {
                      console.error(err);
                      fraudSnapshotAPiCall.current = true;
                    });
                });
              };

              video.play();
              video.remove();
              snap.remove();
            }, 1000);
          }

          if (chanceLeft.current > 0) {
            const description = `You are not allowed to move out of the window. This may result in disqualification and the interview will be ended abruptly.`;
            notification.warning({
              description,
              placement: "topRight",
              duration: 0,
            });
          } else if (chanceLeft.current === 0) {
            endInterviewClickedFlag.current = true;
            alert(
              "You are not allowed to move out of the window. This may result in disqualification and interview will be ended abruptly.",
            );
            setChanceOverModal(true);
          }
          // Delay the screenshot and API call by 2 seconds
          // 2000 ms delay
        }
      } else {
        console.log("Could not access screen share");
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const handleDeviceDisconnect = () => {
    setRejoinModal(true);
  };

  useEffect(() => {
    if (previewConfig?.totalFraudulentChancesLeft === 0) {
      setChanceOverModal(true);
    }
    navigator.mediaDevices.addEventListener(
      "devicechange",
      handleDeviceDisconnect,
    );

    return () => {
      navigator.mediaDevices.removeEventListener(
        "devicechange",
        handleDeviceDisconnect,
      );
    };
  }, []);

  useEffect(() => {
    let interval = null;
    if (previewConfig?.monitoringToolEnabled) {
      checkHealth();
      interval = setInterval(() => {
        checkHealth();
      }, 10000);
    }
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    let interval = null;
    if (previewConfig?.monitoringToolEnabled) {
      fetchMonitorStatus();
      interval = setInterval(
        fetchMonitorStatus,
        previewConfig?.monitoringInterval * 1000 || 60000,
      );
    }

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (previewConfig?.monitoringToolEnabled) {
      if (!isHealthOk) {
        // pause and turn to manual mode
        audioQueueRef.current = [];
        setInterviewMode("Manual");

        setMonitorDisconnectModal(true);
        callAddMonitoringToolDataApi(monitorStatus, false);
      }
    }
  }, [isHealthOk]);

  const [isTourOpen, setIsTourOpen] = useState(false);
  const [tourStep, setTourStep] = useState(0);

  useEffect(() => {
    if (loading) return;
    const hasSeenTour = localStorage.getItem("hasSeenInterviewTour");
    if (!hasSeenTour) {
      const timer = setTimeout(() => {
        setIsTourOpen(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  const handleCloseTour = () => {
    setIsTourOpen(false);
    localStorage.setItem("hasSeenInterviewTour", "true");
  };

  const tourSteps = [
    {
      title: "Start & Stop Answering",
      description: (
        <div>
          <p className="mb-2">
            Click this circular button (or press <strong>Spacebar</strong>) to{" "}
            <strong>Start answering</strong> when you begin speaking.
          </p>
          <p>
            When you finish your answer, click it again to{" "}
            <strong>Stop answering</strong> (or press <strong>Spacebar</strong>)
            so Maya can respond.
          </p>
        </div>
      ),
      target: () => document.getElementById("tour-answer-button"),
      nextButtonProps: { children: "Next" },
    },
    {
      title: "Choose Conversation Mode",
      description: (
        <div>
          <p className="mb-2">
            You can switch between conversation modes at any time:
          </p>
          <ul className="list-disc pl-4 space-y-1">
            <li>
              <strong>Manual Mode:</strong> Control your speech using the
              Start/Stop button or Spacebar.
            </li>
            <li>
              <strong>Hands-free Mode:</strong> Maya automatically listens and
              detects when you speak naturally without the need to press Start
              or Stop buttons.
            </li>
          </ul>
        </div>
      ),
      target: () => document.getElementById("tour-mode-switch"),
      prevButtonProps: { children: "Previous" },
      nextButtonProps: { children: "Finish" },
    },
  ];

  return (
    <>
      {chanceOverModal && (
        <InterviewEndModal
          allowUnloadRef={allowUnloadRef}
          chanceOverModal={chanceOverModal}
          interviewData={interviewData}
          ip={ip}
          setLoading={setLoading}
          videoBlobQueueRef={videoBlobQueueRef}
          screenShareBlobQueueRef={screenShareBlobQueueRef}
          timeRemainingRef={timeRemainingRef}
          stopRecording={stopRecording}
          chatMessagesRef={chatMessagesRef}
          fraudSnapshotAPiCall={fraudSnapshotAPiCall}
        />
      )}
      {rejoinModal && (
        <InterviewRejoinModal
          rejoinModal={rejoinModal}
          interviewData={interviewData}
          conversationHistory={conversationHistory}
          setLoading={setLoading}
          videoBlobQueueRef={videoBlobQueueRef}
          screenShareBlobQueueRef={screenShareBlobQueueRef}
          timeRemainingRef={timeRemainingRef}
          stopRecording={stopRecording}
          chatMessagesRef={chatMessagesRef}
        />
      )}
      {disconnectRejoinModal && (
        <DisconnectRejoinModal
          disconnectRejoinModal={disconnectRejoinModal}
          interviewData={interviewData}
          videoBlobQueueRef={videoBlobQueueRef}
          screenShareBlobQueueRef={screenShareBlobQueueRef}
          timeRemainingRef={timeRemainingRef}
          stopRecording={stopRecording}
          chatMessagesRef={chatMessagesRef}
        />
      )}
      {monitorDisconnectModal && (
        <MonitorDisconnectedModal
          allowUnloadRef={allowUnloadRef}
          monitorDisconnectModal={monitorDisconnectModal}
          setMonitorDisconnectModal={setMonitorDisconnectModal}
          interviewData={interviewData}
          videoBlobQueueRef={videoBlobQueueRef}
          screenShareBlobQueueRef={screenShareBlobQueueRef}
          timeRemainingRef={timeRemainingRef}
          stopRecording={stopRecording}
          chatMessagesRef={chatMessagesRef}
          isHealthOk={isHealthOk}
        />
      )}
      {transcriptionClosedRejoinModal && (
        <TranscriptionClosedRejoinModal
          transcriptionClosedRejoinModal={transcriptionClosedRejoinModal}
          interviewData={interviewData}
          videoBlobQueueRef={videoBlobQueueRef}
          screenShareBlobQueueRef={screenShareBlobQueueRef}
          timeRemainingRef={timeRemainingRef}
          stopRecording={stopRecording}
          chatMessagesRef={chatMessagesRef}
        />
      )}
      {endInterviewRequestModal && (
        <EndInterviewRequestModal
          socket={socket}
          allowUnloadRef={allowUnloadRef}
          endInterviewRequestModal={endInterviewRequestModal}
          setEndInterviewRequestModal={setEndInterviewRequestModal}
          interviewData={interviewData}
          ip={ip}
          setLoading={setLoading}
          videoBlobQueueRef={videoBlobQueueRef}
          screenShareBlobQueueRef={screenShareBlobQueueRef}
          timeRemainingRef={timeRemainingRef}
          stopRecording={stopRecording}
          chatMessagesRef={chatMessagesRef}
        />
      )}
      {loading && <Loader />}
      <div className="login-landing-page min-h-screen bg-primaryBg text-primaryWhite gap-[.2rem] px-5 lg:px-8 py-2 flex flex-col justify-between items-center">
        {previewConfig?.videoRecordingRequired && (
          <DraggableVideo
            currentVideoStream={currentVideoStream}
            currentAudioStream={currentVideoStream}
          />
        )}
        <TwoWayNavbar
          allowUnloadRef={allowUnloadRef}
          interviewMode={interviewMode}
          setInterviewMode={setInterviewMode}
          timeRemaining={timeRemaining}
          chatMessagesRef={chatMessagesRef}
          endInterviewClickedFlag={endInterviewClickedFlag}
          conversationHistory={conversationHistory}
          timeRemainingRef={timeRemainingRef}
          socket={socket}
          deepgramStatus={deepgramStatus}
          previewConfig={previewConfig}
          setLoading={setLoading}
          interviewData={interviewData}
          ip={ip}
          videoBlobQueueRef={videoBlobQueueRef}
          stopRecording={stopRecording}
          screenShareBlobQueueRef={screenShareBlobQueueRef}
          monitorStatus={monitorStatus}
          fetchMonitorStatus={fetchMonitorStatus}
        />
        <TwoWayMain
          socket={socket}
          interviewMode={interviewMode}
          setInterviewMode={setInterviewMode}
          audioContextRef={audioContextRef}
          audioQueueRef={audioQueueRef}
          microphoneGainNodeRef={microphoneGainNodeRef}
          deepgramStatus={deepgramStatus}
          deepgramAudioRecorder={deepgramAudioRecorder}
          setDeepgramAudioRecorder={setDeepgramAudioRecorder}
          interviewData={interviewData}
          conversationHistory={conversationHistory}
          chatMessages={chatMessages}
          setChatMessages={setChatMessages}
          currentAudioStream={currentAudioStream}
          ip={ip}
          setLoading={setLoading}
          videoBlobQueueRef={videoBlobQueueRef}
          screenShareBlobQueueRef={screenShareBlobQueueRef}
          timeRemainingRef={timeRemainingRef}
          stopRecording={stopRecording}
          chatMessagesRef={chatMessagesRef}
          allowUnloadRef={allowUnloadRef}
        />
        <Footer />
        <Tour
          open={isTourOpen}
          onClose={handleCloseTour}
          current={tourStep}
          onChange={setTourStep}
          steps={tourSteps}
          rootClassName="custom-interview-tour"
        />
      </div>
    </>
  );
}

export default TwoWayInterview;
